/**
 * Lookup tables and formatters the `item-<column>` slots of `TrucksTable.vue`
 * render with — the value side of a cell, next to `AsyncCell.vue`, which is the
 * loading side. The columns themselves (which exist, which are picked, in what
 * order) live in `@/composables/useTruckColumns`.
 */

// Parts the address is built from. Shared between the cell and the copy action
// so both produce exactly the same string.
export const ADDRESS_FIELDS = ['country', 'state', 'province', 'county', 'village', 'road']

// Nearest city, most specific populated place first: whichever of these the
// reverse geocoding response carries is the one shown.
export const CITY_FIELDS = ['city', 'town', 'village', 'municipality', 'hamlet', 'county']

// Tachograph activity codes, as sent in `lastpoint.activity`.
export const DRIVER_ACTIVITIES = {
    0: { label: 'rest', icon: 'fa-solid fa-bed', color: 'var(--rest-color)' },
    1: { label: 'availability', icon: 'fak fa-availability', color: 'var(--availability-color)' },
    2: { label: 'work', icon: 'fak fa-work', color: 'var(--work-color)' },
    3: { label: 'driving', icon: 'fa-solid fa-steering-wheel', color: 'var(--driving-color)' }
}

// Signal strength (0-5) to its Font Awesome icon.
export const GSM_SIGNAL_ICONS = {
    0: 'signal-slash',
    1: 'signal-weak',
    2: 'signal-fair',
    3: 'signal-good',
    4: 'signal-strong',
    5: 'signal'
}

// Thousands separator: 1234567 -> 1.234.567
export function formatKilometers(value) {
    if (!value) return ''

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' km'
}
